import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { call, getContext, put } from 'redux-saga/effects';
import { setBusinessAppointmentsAction } from '../../../actions/businessAppointments';
import { getBusinessPossibleAppointments } from '../../../services/businessPossibleAppointments/getBusinessPossibleAppointments';
import { TBusinessAppoinment } from '../../../services/businessPossibleAppointments/getBusinessPossibleAppointments/types';

export function* getBusinessAppointments() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  const { businessAppointments }: TBusinessAppoinment = yield call(getBusinessPossibleAppointments, {
    httpApi,
    logger,
  });

  yield put(setBusinessAppointmentsAction(businessAppointments));
}
